import React from "react";
import classNames from "classnames/bind";
import { LuSearch, LuUserPlus } from "react-icons/lu";

import styles from "./Account.module.scss";

const cx = classNames.bind(styles);

function getOptionInfo(item) {
    if (item == null) return null;

    if (typeof item === "string") {
        const trimmed = item.trim();
        return trimmed ? { value: trimmed, label: trimmed } : null;
    }

    if (typeof item === "object") {
        const rawValue =
            item._id ??
            item.id ??
            item.value ??
            item.code ??
            item.slug ??
            item.key ??
            item;
        const rawLabel =
            item.name ??
            item.title ??
            item.label ??
            item.displayName ??
            item.value ??
            item.code ??
            item.slug ??
            item.key ??
            rawValue;

        const value = rawValue != null ? String(rawValue).trim() : "";
        const label = rawLabel != null ? String(rawLabel).trim() : value;

        if (!value && !label) return null;

        return {
            value: value || label,
            label: label || value,
        };
    }

    const normalized = String(item).trim();
    return normalized ? { value: normalized, label: normalized } : null;
}

function buildOptions(items) {
    const seen = new Set();
    return items
        .map(getOptionInfo)
        .filter(Boolean)
        .filter((option) => {
            const key = option.value.toLowerCase();
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
        });
}

function AccountToolbar({
    searchTerm,
    onSearchChange,
    departments = [],
    positions = [],
    selectedDepartment = "",
    selectedPosition = "",
    onDepartmentChange = () => {},
    onPositionChange = () => {},
    onOpenCreate,
}) {
    const departmentOptions = React.useMemo(() => buildOptions(departments), [departments]);

    const positionOptions = React.useMemo(() => buildOptions(positions), [positions]);

    const controlsStyle = {
        display: "flex",
        flex: 1,
        gap: "0.85rem",
        flexWrap: "wrap",
        alignItems: "center",
    };

    const selectWrapperStyle = {
        flex: "0 0 200px",
        minWidth: "180px",
    };

    const selectStyle = {
        width: "100%",
        padding: "0.65rem 0.8rem",
        borderRadius: "14px",
        border: "1px solid rgba(203, 213, 225, 0.9)",
        background: "rgba(248, 250, 252, 0.9)",
        fontSize: "0.9rem",
        fontFamily: "inherit",
        color: "#0f172a",
    };

    return (
        <div className={cx("toolbar")}>
            <div className={cx("toolbar-controls")} style={controlsStyle}>
                <div className={cx("search-field")}>
                    <LuSearch />
                    <input
                        type="text"
                        placeholder="Tìm kiếm theo tên, phòng ban, chức vụ..."
                        value={searchTerm}
                        onChange={onSearchChange}
                    />
                </div>
                <div className={cx("filter-field")} style={selectWrapperStyle}>
                    <select
                        value={selectedDepartment}
                        onChange={onDepartmentChange}
                        aria-label="Lọc theo chức vụ"
                        style={selectStyle}
                    >
                        <option value="">Tất cả chức vụ</option>
                        {departmentOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                </div>
                <div className={cx("filter-field")} style={selectWrapperStyle}>
                    <select
                        value={selectedPosition}
                        onChange={onPositionChange}
                        aria-label="Lọc theo phòng ban"
                        style={selectStyle}
                    >
                        <option value="">Tất cả phòng ban</option>
                        {positionOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <button type="button" className={cx("primary-button")} onClick={onOpenCreate}>
                <LuUserPlus /> Tạo tài khoản
            </button>
        </div>
    );
}

export default AccountToolbar;
